import { render, staticRenderFns } from "./PushHistoryTable.vue?vue&type=template&id=6a1d3722"
import script from "./PushHistoryTable.vue?vue&type=script&lang=ts"
export * from "./PushHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports